import axios from 'axios';
import { getToken } from '@/utils/auth';
import { blobValidate } from '@/utils/ruoyi';
import { saveAs } from 'file-saver';
import { Message } from 'element-ui';
export function formatNumber(n) {
    n = n.toString();
    return n[1] ? n : '0' + n;
}
let baseURL = process.env.VUE_APP_BASE_API;
//   获取当月最后一天
export function getLastDay(newDate) {
    var seperator1 = '-';
    var date = new Date();
    if (newDate) {
        date = newDate;
    }
    var new_month = date.getMonth() + 1;
    var new_year = date.getFullYear();
    //取当前的年份
    var new_date = new Date(new_year, new_month, 1);
    //取当年当月中的第一天
    // (new Date(new_date.getTime()-1000*60*60*24)).getDate();
    //获取当月最后一天日期
    var currentdate =
        new_year + seperator1 + new_month + seperator1 + new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate();
    return [new_year, new_month, new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate()]
        .map(formatNumber)
        .join('-');
}
//   获取当月第一天
export function getCurrentMonthFirst(newDate) {
    let date = new Date();
    if (newDate) {
        date = newDate;
    }
    date.setDate(1);
    var month = parseInt(date.getMonth() + 1);
    var day = date.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return date.getFullYear() + '-' + month + '-' + day;
}
// 下载图片
export function downloadIamge(imgsrc, name) {
    //下载图片地址和图片名
    let image = new Image();
    // 解决跨域 canvas 污染问题
    image.setAttribute('crossorigin', 'anonymous');
    image.onload = function () {
        let canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL('image/png'); //得到图片的base64编码数据
        let a = document.createElement('a'); // 生成一个a元素
        let event = new MouseEvent('click'); // 创建一个单击事件
        a.download = name || 'photo'; // 设置图片名称
        a.href = url; // 将生成的url设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
    };
    image.src = imgsrc;
}
// 下载文件
export function downLoadFile(resource, fileName) {
    var url = baseURL + '/common/download/resource?resource=' + encodeURIComponent(resource);
    axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: { Authorization: 'Bearer ' + getToken() }
    }).then(async (res) => {
        const isLogin = await blobValidate(res.data);
        if (isLogin) {
            const blob = new Blob([res.data]);
            if (fileName)
                fileName =
                    fileName +
                    decodeURIComponent(res.headers['download-filename']).slice(
                        decodeURIComponent(res.headers['download-filename']).indexOf('.')
                    );
            console.log(
                res.headers['download-filename'].slice(),
                decodeURIComponent(res.headers['download-filename']).indexOf('.')
            );
            saveAs(blob, fileName || decodeURIComponent(res.headers['download-filename']));
        } else {
            Message.error(res.data);
        }
    });
}
